import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'

import './style.scss'

export default class Terminology extends Component {
    static propTypes = {
        translates: PropTypes.shape({
            terminologyToggleText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            terminologyScoringText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            terminologyKreditText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            terminologyTransactionText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            terminologyLimitsText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
        customData: PropTypes.object,
        saveCustomData: PropTypes.func,
    }

    constructor() {
        super()

        this.state = { open: false }
    }

    toggleTerminologyTexts = () => {
        const { saveCustomData, customData } = this.props

        this.setState((prevState) => {
            saveCustomData({ ...customData, isTerminologyOpen: !prevState.open })

            return { open: !prevState.open }
        })
    }

    render() {
        const {
            translates: {
                terminologyToggleText,
                terminologyScoringText,
                terminologyKreditText,
                terminologyTransactionText,
                terminologyLimitsText,
            },
        } = this.props
        const { open } = this.state

        return (
            <div className={'terminology-wrap'}>
                <div onClick={this.toggleTerminologyTexts} className={'terminology-toggle'}>
                    <div className={cx('terminology-toggle-icon', open ? 'expand' : 'collapse')} />
                    <div className={'terminology-toggle-button'}>{terminologyToggleText}</div>
                </div>
                {open && <div className={'terminology-texts'}>{terminologyScoringText}</div>}
                {open && <div className={'terminology-texts'}>{terminologyKreditText}</div>}
                {open && <div className={'terminology-texts'}>{terminologyTransactionText}</div>}
                {open && <div className={'terminology-texts'}>{terminologyLimitsText}</div>}
            </div>
        )
    }
}
